import React from 'react';
import './ComingSoonPage.css';

const ComingSoonPage = () => {
  return (
    <div className="coming-soon-page">
      <div className="coming-soon-content">
        <h1>Coming Soon</h1>
        <p>We're working hard to bring you an amazing collection of glasses!</p>
        <p>Check back soon for updates.</p>
        <a href="/" className="back-home-btn">Back to Home</a>
      </div>
    </div>
  );
};

export default ComingSoonPage;
